import { useCallback, useState } from "react"

import { resetPasswordConfirmErrorTranslationKeys, ResetPasswordConfirmFormFieldValues } from "./types"
import { useLoginService } from "../../providers/LoginService"
import { useNavigationService } from "../../providers/NavigationService"

export const useSubmitHandler = (executeOnSuccess) => {
	const { confirmResetPassword } = useLoginService()
	const { useParams } = useNavigationService()
	const params = useParams()

	const [{ submitting, data, error }, setRequestStatus] = useState<State>(new State())

	const validate = useCallback((values) => {
		if (values.newPassword?.length < 5) return resetPasswordConfirmErrorTranslationKeys.InvalidLength
		if (values.newPassword?.includes(" ")) return resetPasswordConfirmErrorTranslationKeys.ContainsSpaces
		if (values.newPassword !== values.newPasswordConfirm) return resetPasswordConfirmErrorTranslationKeys.PasswordsDoNotMatch
		return null
	}, [])

	const handleSubmit = (values: ResetPasswordConfirmFormFieldValues) => {
		const errorMessageKey = validate(values)
		if (errorMessageKey) return setRequestStatus((prev) => ({ ...prev, error: errorMessageKey }))

		const formData = new FormData()
		formData.append("newPassword", values.newPassword)
		formData.append("newPasswordConfirm", values.newPasswordConfirm)
		formData.append("token", params?.token)

		setRequestStatus((prev) => ({ ...prev, submitting: true, error: null }))
		confirmResetPassword(formData)
			.then((result) => {
				setRequestStatus({ submitting: false, data: result.data, error: null })
				executeOnSuccess?.()
			})
			.catch((error) => {
				const errorMessage = error?.response?.data?.Message === "RequestValidityExpired"
					? "Author.Login:RequestValidityExpired" : ""

				setRequestStatus((prev) => ({ ...prev, submitting: false, error: errorMessage }))
				console.error(error)
			})
	}

	return {
		submitting,
		data,
		error,
		handleSubmit,
		cleanError: () => setRequestStatus((prev) => ({ ...prev, error: null }))
	}
}

class State {
	submitting: boolean = false
	data: any | null = null
	error: string | null = null
}
